module.exports = __webpack_public_path__ + "media/svg/account-outline-06ada3d8.svg";